export default {
  methods: {
    getElapsedTimeString ({ secondsInterval }) {
      const timeComponents = this.$getElapsedTime({ secondsInterval })
      let finalString = ''
      if (timeComponents.years) finalString += `${timeComponents.years} ${this.$tc('years')}, `
      if (timeComponents.months) finalString += `${timeComponents.months} ${this.$tc('months')}, `
      if (timeComponents.days) finalString += `${timeComponents.days} ${this.$tc('days')}, `
      if (timeComponents.hours) finalString += `${timeComponents.hours} ${this.$tc('hours')}, `
      if (timeComponents.minutes) finalString += `${timeComponents.minutes} ${this.$tc('minutes')}, `
      if (timeComponents.seconds) finalString += `${timeComponents.seconds} ${this.$tc('seconds')}`
      return finalString
    }
  }
}
